export const BG_COLOR = '#ff0d7b';
export const FILL_COLOR = '#ffffff';

export const TITLE_COLOR = '#ffffff';
export const BIB_NUMBER_COLOR = '#ff0d7b';
export const NAME_COLOR = '#000000';
export const COMPANY_COLOR = '#000000';

export const HEIGHT = 2100;
export const WIDTH = 3000;

export const TITLE = 'Odysséa La Réunion 2020';
// The event slug must unique for each events.
// The event slug is used to request Firestore.
export const EVENT_SLUG = 'odyssea-reunion-2020';

export const BIB_ORGANIZER_LOGO_WIDTH = 1061;
export const BIB_ORGANIZER_LOGO_HEIGHT = 291;
export const BIB_ORGANIZER_POS_X = WIDTH / 2 - (BIB_ORGANIZER_LOGO_WIDTH) / 2;
export const BIB_ORGANIZER_POS_Y = 30;

// Sponsor logo Groupe CRC
export const BIB_SPONSOR_LOGO_WIDTH = 1537 / 2;
export const BIB_SPONSOR_LOGO_HEIGHT = 307 / 2;
export const BIB_SPONSOR_POS_X = 200;
export const BIB_SPONSOR_POS_Y = HEIGHT - 375;

// Sponsor logo Canal Box
export const BIB_SPONSOR2_LOGO_WIDTH = 657 / 2;
export const BIB_SPONSOR2_LOGO_HEIGHT = 311 / 2;
export const BIB_SPONSOR2_POS_X = WIDTH / 2 - 425;
export const BIB_SPONSOR2_POS_Y = HEIGHT - 375;

// Sponsor logo Région
export const BIB_SPONSOR3_LOGO_WIDTH = 1807 / 2;
export const BIB_SPONSOR3_LOGO_HEIGHT = 255 / 2;
export const BIB_SPONSOR3_POS_X = WIDTH / 2 + 35;
export const BIB_SPONSOR3_POS_Y = HEIGHT - 375;

// Sponsor logo Crédit Agricole
export const BIB_SPONSOR4_LOGO_WIDTH = 438 / 2;
export const BIB_SPONSOR4_LOGO_HEIGHT = 308 / 2;
export const BIB_SPONSOR4_POS_X = WIDTH - 450;
export const BIB_SPONSOR4_POS_Y = HEIGHT - 375;

export const BIB_COMPANY_NAME_MANDATORY = true;
export const BIB_NAME_MANDATORY = false;
